import t from "../../../helpers/t";
import FormItem from "../../../components/FormItem";
import React, {useEffect, useState} from "react";
import {$} from "../../../../../vendor";

const OrdersSelect = (props) => {
    const {selectedOrder, setSelectedOrder, dispatch, facility} = props;
    const addOrder = (order) => {
        setSelectedOrder(order);
        $('#inbooma-select-box_order input').css('border-color','rgb(227, 227, 227)');
    }

    const onRemoveOrder = () => {
       setSelectedOrder([]);
    };

    const fields =  {
        fieldMap: {
            order_nbr: {
                label: t("order_nbr"),
                number: "1",
                class: "inb-select-width-1",
                type: 'default',
                style: {maxWidth: "20%", padding: 0}
            },
            username: {
                label: t("user"),
                number: "2",
                class: "inb-select-width-3",
                type: 'extra',
                extra: {
                    user:[
                        'first_name',
                        'last_name'
                    ],
                    seperator: " ",
                    descriptor:'object'
                },
                style: {maxWidth: "35%", padding: 0}
            },
            timeperiod: {
                label: t('timeperiod'),
                number: "3",
                class: "inb-select-width-3",
                type: 'extra',
                extra: {
                    reservations:[
                        'begin',
                        'end'
                    ],
                    seperator: ' - ',
                    descriptor:'array',
                    type:'date'
                }
            }
        },
        fieldNames: [
            "order_nbr", "username", "timeperiod"
        ]
    };
    const searchParams = {
        param: "order_nbr",
        checkFields: ["order_nbr"]
    };
    return ( <>
        <FormItem
            name="orders"
            type="inboomaSelect"
            id={"orderSelect"}
            sortBy={'name'}
            sortDirection={'asc'}
            advanced={true}
            placeholder={t('select_${a}',{a:t('order', null, 'capital')})}
            selectedItems={selectedOrder}
            setSelectedItems={setSelectedOrder}
            onChangeHandler={addOrder}
            dispatch={dispatch}
            container='order-vcard'
            extraStyle={{width:"700px"}}
            multiSelect={false}
            onReset={onRemoveOrder}
            fields={fields}
            searchParams={searchParams}
            model='order'
            label={t('order', null, 'capital')}
            extraFilter={{find:'full',limit: 40,sort: 'order_nbr', direction: "desc", finder:'PinBoxBooking'}}
            mediumWidth={12}
            smallWidth={12}
        />
    </>);
}
export default OrdersSelect;